import financeiroApi from './financeiroApi';

const PATH = '/api/v1/backend/conta-pagar';

export default {
  cadastrar: async (contaspagar, permitirDuplicada) => {
    const url = `${PATH}?permitirDuplicada=${!!permitirDuplicada}`;
    return financeiroApi.post(`${url}`, contaspagar);
  },
  buscarPorId: async (key) => {
    return financeiroApi.get(`${PATH}/${encodeURIComponent(key)}`);
  },
  buscarHistorico: async (id) => {
    return financeiroApi.get(`${PATH}/${encodeURIComponent(id)}/historico`);
  },
  buscar: async (params) =>
    financeiroApi.get(`${PATH}`, {
      params,
    }),

  atualizar: async (id, contaspagar, permitirDuplicada) => {
    const url = `${PATH}/${id}?permitirDuplicada=${!!permitirDuplicada}`;
    return financeiroApi.put(`${url}`, contaspagar);
  },

  excluir: (filtro) => {
    return financeiroApi.delete(`${PATH}`, { data: filtro });
  },
  baixarContas: (baixaDespesas) => {
    return financeiroApi.put(`${PATH}/baixa`, baixaDespesas);
  },
  cancelarBaixas: (despesasIds) => {
    return financeiroApi.delete(`${PATH}/baixa`, { data: { despesasIds } });
  },
  somatorio: (filtro) => {
    return financeiroApi.post(`${PATH}/somatorio`, filtro);
  },
  upload: async (anexo) => {
    return financeiroApi.put(`${PATH}/anexo/upload`, anexo, {
      headers: {
        'Content-Type': 'multipart/form-data',
        type: 'formData',
      },
    });
  },
  download: (url) => {
    return financeiroApi.get(url);
  },
  getAnexoUrl: (anexoId) => {
    return `${PATH}/anexo/download/${anexoId}`;
  },
  obterModelo: () => {
    return financeiroApi.get(`${PATH}/modelo`);
  },
  importar: async (arquivo, idNotificacao) => {
    try {
      return financeiroApi.post(`${PATH}/importar?idNotificacao=${idNotificacao}`, arquivo, {
        headers: {
          'Content-Type': 'multipart/form-data',
          type: 'formData',
        },
      });
    } catch (error) {
      throw error;
    }
  },
  getAnexoUrlDownload: () => {
    return `${PATH}/anexo/download`;
  },
};
